import React from 'react';
export function AuthorSection() {
  return <section className="bg-alternate py-10 md:py-24 px-4" data-id="element-1">
      <div className="max-w-3xl mx-auto bg-primary rounded-2xl md:rounded-3xl p-6 md:p-12 shadow-sm border border-border" data-id="element-2">
        <div className="text-center mb-6 md:mb-8" data-id="element-3">
          <h2 className="text-xl md:text-3xl font-bold text-text-primary mb-3 md:mb-4" data-id="element-4">
            Un enfoque basado en la realidad, no en la teoría
          </h2>
          <div className="w-12 h-1 bg-trust mx-auto rounded-full" data-id="element-5"></div>
        </div>

        <div className="space-y-4 md:space-y-6 text-text-secondary text-base md:text-lg leading-relaxed" data-id="element-6">
          <p data-id="element-7">
            Esta guía no fue escrita desde un escritorio lejano por alguien que
            no entiende lo que es lidiar con un adolescente a las 11 de la noche
            porque no quiere apagar la consola.
          </p>
          <p data-id="element-8">
            Ha sido desarrollada recopilando las estrategias más efectivas de
            psicología familiar moderna, combinadas con la experiencia real de
            cientos de madres que han logrado transformar su hogar de un campo
            de batalla a un espacio de respeto mutuo.
          </p>
          <p data-id="element-9">
            Creemos firmemente que{' '}
            <strong className="text-text-primary font-semibold" data-id="element-10">
              tú eres la mejor guía para tu hijo
            </strong>
            . Solo necesitas las herramientas adecuadas para navegar esta nueva
            era digital.
          </p>
        </div>
      </div>
    </section>;
}